import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "supermodal",
  templateUrl: "./supermodal.component.html",
})
export class SupermodalComponent {
  isOpen: boolean = false;
  @Output()
  onClose = new EventEmitter();
  @Input()
  displayLoading: boolean = false;
  @Input()
  displayCloseButton: boolean = true;
  @Input()
  aspect: String;
  @Input()
  title: String;
  @Input()
  centerTitle: boolean = false;
  @Input()
  duration: number = null;

  open() {
    this.isOpen = true;
    console.log("current title", this.title);
    if (this.duration) {
      setTimeout(() => {
        this.close();
      }, this.duration);
    }
  }

  close() {
    this.isOpen = false;

    this.onClose.emit();
  }
}
